const domReady = TPL => {
  const blockLead = document.querySelector('.block-lead');
  $(function(){
    blockLead.classList.add('loaded');
  })
};

export default function RECRUIT () {
  $(window).on('load', domReady);
}